import React, { createContext, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Create context
const ToastContext = createContext();

// Custom hook to use the toast context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

// Toast provider component
export const ToastProvider = ({ children }) => {
  // Convenience methods for different toast types
  const showToast = (message, type = 'info', options = {}) => {
    toast[type](message, options);
  };

  const success = (message, options) => showToast(message, 'success', options);
  const error = (message, options) => showToast(message, 'error', options);
  const warning = (message, options) => showToast(message, 'warning', options);
  const info = (message, options) => showToast(message, 'info', options);

  // Value to be provided by the context
  const value = {
    showToast,
    success,
    error,
    warning,
    info
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

export default ToastProvider;